import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState, forwardRef } from 'react';
import { TaktIdProvider, createStormTaktId, Menu, MenuItemLink, IconButton } from '@amzn/storm-ui';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BLE3wELi-CV9fXVbx.js';
import { f as faQuestionCircle } from '../../LocalModules/storm-ui-icons/dist/esm/fortawesome-free-regular-svg-icons-dg-C6Njp-DdObqI9E.js';

const HelpDropdown = ({
  helpInfo,
  taktId,
  taktValue
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    formatMessage
  } = useIntl();
  const handleToggle = () => setIsOpen(!isOpen);
  const IconButtonTrigger = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(IconButton, _extends({
    buttonRef: ref
  }, props)));
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('page-header-help-dropdown')
  }, /*#__PURE__*/React__default.createElement(Menu, {
    id: "storm-ui-focus-page-header-help-dropdown",
    trigger: /*#__PURE__*/React__default.createElement(IconButtonTrigger, {
      "data-testid": "help-dropdown-trigger-button",
      small: true,
      variant: "transparent",
      icon: faQuestionCircle,
      onClick: handleToggle,
      label: formatMessage({
        id: 'open-the-help-dropdown'
      }),
      "aria-label": formatMessage({
        id: 'open-the-help-dropdown'
      }),
      "aria-haspopup": "true"
    }),
    isOpen: isOpen
  }, helpInfo.map(({
    label,
    url,
    isExternal,
    uid
  }) => /*#__PURE__*/React__default.createElement(MenuItemLink, {
    href: url,
    external: isExternal,
    id: uid,
    key: uid
  }, label))));
};

export { HelpDropdown as H };
//# sourceMappingURL=HelpDropdown-DVWuGH0x.js.map
